import axios from "axios";
import { clearAllLocalStorage } from "./utility";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
});

axiosInstance.interceptors.request.use(async (config: any) => {
    const tenant = window.location.host.split('.')[0];
    return {
        ...config,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "x-tenant": tenant,
            ...(config.headers || {})
        },
    };
});

axiosInstance.interceptors.response.use(
    (response: any) => {
        return response;
    },
    (error: any) => {
        if (error?.response?.statusCode === 401 || error?.response?.status === 401) {
            clearAllLocalStorage()
            window.location.href = "/user-auth/login";
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;